var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcondownload = function SvgIcondownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 3,
    height: 14,
    fill: "none",
    viewBox: "0 0 3 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00588F",
    d: "M1.5 5.5A1.5 1.5 0 0 0 0 7c0 .844.656 1.5 1.5 1.5A1.5 1.5 0 0 0 3 7c0-.812-.687-1.5-1.5-1.5M0 2.25c0 .844.656 1.5 1.5 1.5A1.5 1.5 0 0 0 3 2.25c0-.812-.687-1.5-1.5-1.5A1.5 1.5 0 0 0 0 2.25m0 9.5c0 .844.656 1.5 1.5 1.5a1.5 1.5 0 0 0 1.5-1.5c0-.812-.687-1.5-1.5-1.5a1.5 1.5 0 0 0-1.5 1.5"
  })));
};
export default SvgIcondownload;